import React from 'react';
import { Accordion, Row, Col, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileMedical, faHeartbeat, faNotesMedical, faFilePrescription, faFileSignature, faStethoscope } from '@fortawesome/free-solid-svg-icons';
import config from '../../config';
import { useEntidadeContext } from '../../EntidadeContext';

const HistoricoTab = ({ historico }) => {
    const { currentEntidade } = useEntidadeContext();

    if (!historico || historico.length === 0) {
        return <p>Nenhum histórico de consulta encontrado para este paciente.</p>;
    }

    return (
        <div className="timeline-container" style={{ maxHeight: '50vh', overflowY: 'auto' }}>
            {historico.map((consulta) => {
                let procedimentosRealizados = [];
                try {
                    if (consulta.procedimentos) {
                        const parsed = JSON.parse(consulta.procedimentos);
                        if (Array.isArray(parsed) && parsed.length > 0 && parsed.some(p => p.nome)) {
                            procedimentosRealizados = parsed;
                        }
                    }
                } catch (e) {
                    console.error("Erro ao parsear procedimentos do histórico:", e);
                }

                return (
                    <div key={consulta.id} className="timeline-item mb-3">
                        <div className="timeline-icon"><FontAwesomeIcon icon={faFileMedical} /></div>
                        <div className="timeline-content" style={{ marginLeft: '28px' }}>
                            <div className="timeline-date">{new Date(consulta.data_consulta).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}</div>
                            <Row className="align-items-start">
                                <Col md={8}>
                                    <p className="mb-1"><strong>Queixa:</strong> {consulta.queixa_principal || "Sem relato registrado."}</p>
                                    {consulta.observacoes && <small className="text-muted d-block">Obs: {consulta.observacoes}</small>}
                                </Col>
                                <Col md={4} className="d-flex justify-content-md-end align-items-center mt-2 mt-md-0">
                                    {consulta.foto_path_antes && <Image src={`${config.apiBaseURL}/storage/entidade/${currentEntidade.id}/fotos_pacientes/${consulta.foto_path_antes}`} alt="Antes" className="timeline-photo" />}
                                    {consulta.foto_path_depois && <Image src={`${config.apiBaseURL}/storage/entidade/${currentEntidade.id}/fotos_pacientes/${consulta.foto_path_depois}`} alt="Depois" className="timeline-photo" />}
                                </Col>
                            </Row>
                            <Accordion className="mt-2">
                                <Accordion.Item eventKey={String(consulta.id)}>
                                    <Accordion.Header>Ver detalhes da consulta</Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            <Col md={12}>
                                                <h6><FontAwesomeIcon icon={faHeartbeat} className="me-2" />Sinais Vitais</h6>
                                                <div className="small text-muted">
                                                    <span>PA: <strong>{consulta.pressao_arterial || 'N/A'}</strong></span> |
                                                    <span> Temp: <strong>{consulta.temperatura || 'N/A'}°C</strong></span> |
                                                    <span> FC: <strong>{consulta.frequencia_cardiaca || 'N/A'} bpm</strong></span> |
                                                    <span> Sat O₂: <strong>{consulta.saturacao_oxigenio || 'N/A'}%</strong></span>
                                                </div>
                                                <hr />
                                            </Col>
                                            <Col md={6}>
                                                <h6><FontAwesomeIcon icon={faNotesMedical} className="me-2" />Diagnóstico</h6>
                                                <p className="small">{consulta.diagnostico || 'Nenhum diagnóstico registrado.'}</p>
                                            </Col>
                                            <Col md={6}>
                                                <h6><FontAwesomeIcon icon={faFilePrescription} className="me-2" />Prescrição</h6>
                                                <p className="small">{consulta.prescricao || 'Nenhuma prescrição registrada.'}</p>
                                            </Col>
                                            <Col md={12}><hr /></Col>
                                            <Col md={6}>
                                                <h6><FontAwesomeIcon icon={faFileSignature} className="me-2" />Plano de Tratamento</h6>
                                                <p className="small">{consulta.plano_tratamento || 'Nenhum plano de tratamento registrado.'}</p>
                                            </Col>
                                            <Col md={6}>
                                                <h6><FontAwesomeIcon icon={faStethoscope} className="me-2" />Procedimentos Realizados</h6>
                                                {procedimentosRealizados.length > 0 ? (
                                                    <ul>
                                                        {procedimentosRealizados.map((proc, index) => proc.nome && <li key={index}>{proc.nome}</li>)}
                                                    </ul>
                                                ) : <p className="small">Nenhum procedimento registrado.</p>}
                                            </Col>
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default HistoricoTab;
